import { Event } from '@guiker/event'

export const filterConsentAndBackgroundCheckEvents = (events: Event<unknown, {}, string, string, string>[]) =>
  events.filter(
    (event) => (event.entity === 'PROFILE' && event.type === 'CONSENT_UPDATED') || event.entity === 'BACKGROUND_CHECK',
  )
